export default __webpack_public_path__ + "static/media/q38_new.520273a5.png";